import { render, staticRenderFns } from "./lotto-report.vue?vue&type=template&id=6d992cf6&scoped=true&"
import script from "./lotto-report.vue?vue&type=script&lang=js&"
export * from "./lotto-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d992cf6",
  null
  
)

export default component.exports